/* Robotow fit engine.
   Port of the prototype's fitment-core.js. Same search, same three fit states,
   same follow-up outcomes. Data comes from one URL: /pages/fitment-data once the
   metaobjects are loaded, the sanitized rt-fitment.json asset until then. Both
   return the same shape, so there is one code path. */
(function (root) {
  "use strict";

  var DATA = null;
  var waiting = [];
  var CFG = {};

  function readConfig() {
    var el = document.getElementById("rt-config");
    if (!el) return {};
    try { return JSON.parse(el.textContent || "{}"); } catch (e) { return {}; }
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function load() {
    CFG = readConfig();
    if (!CFG.dataUrl) return;
    fetch(CFG.dataUrl, { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error("fit data " + r.status); return r.json(); })
      .then(function (d) {
        d.aircraft = (d.aircraft || []).slice().sort(function (a, b) { return (a.sort || 0) - (b.sort || 0); });
        d.adapters = d.adapters || {};
        d.kits = d.kits || {};
        d.units = d.units || {};
        // One airplane, one entry. "<id>-pin" is the tow-pin version of "<id>": it leaves the list and the counts,
        // and the airplane's own question picks the adapter. It stays reachable by id for links made before.
        var byId = {}, variants = {};
        d.aircraft.forEach(function (a) { byId[a.id] = a; });
        d.aircraft = d.aircraft.filter(function (a) {
          var m = /^(.+)-pin$/.exec(a.id || "");
          if (m && byId[m[1]]) { variants[a.id] = a; return false; }
          return true;
        });
        d.aircraft.forEach(function (a) {
          ((a.follow_up && a.follow_up.answers) || []).forEach(function (ans) {
            var v = ans.outcome === "route" ? variants[ans.target] : null;
            if (v) { ans.outcome = "adapter"; ans.target = v.adapter; ans.display = v.display; }
          });
        });
        d.variants = variants;
        d.counts = { listed: 0, confirm: 0, no_fit: 0 };
        d.aircraft.forEach(function (a) { if (d.counts[a.status] != null) d.counts[a.status]++; });
        DATA = d;
        waiting.splice(0).forEach(function (cb) { try { cb(DATA); } catch (e) { if (window.console) console.error(e); } });
        document.dispatchEvent(new CustomEvent("robotow:fit-data", { detail: { count: d.aircraft.length } }));
      })
      .catch(function (e) {
        if (window.console) console.error(e);
        document.documentElement.setAttribute("data-rt-fit-error", "1");
      });
  }

  function ready(cb) { if (DATA) cb(DATA); else waiting.push(cb); }

  function norm(s) { return (s || "").toLowerCase().trim(); }

  function searchAircraft(query) {
    var q = norm(query);
    if (!q || !DATA) return [];
    var starts = [], contains = [];
    DATA.aircraft.forEach(function (a) {
      var hay = [a.display].concat(a.synonyms || []).map(norm);
      if (hay.some(function (h) { return h.indexOf(q) === 0; })) { starts.push(a); return; }
      if (hay.some(function (h) { return h.indexOf(q) !== -1; })) contains.push(a);
    });
    return starts.concat(contains).slice(0, 8);
  }

  function getAircraft(id) {
    if (!DATA || !id) return null;
    for (var i = 0; i < DATA.aircraft.length; i++) if (DATA.aircraft[i].id === id) return DATA.aircraft[i];
    return (DATA.variants && DATA.variants[id]) || null;
  }
  function getAdapter(pn) { return pn && DATA ? DATA.adapters[pn] || null : null; }
  function getUnit(pn) { return pn && DATA ? DATA.units[pn] || null : null; }

  // Kit SKU rule (Max Jones, Sep 21): <series><battery>-<adapter sku>.
  // Series 65 standard, 66 Pro, 67 SF. Battery 05 = 5Ah, 08 = 8Ah.
  function buildSku(unitPn, battery, adapterPn) {
    var u = getUnit(unitPn), a = getAdapter(adapterPn);
    if (!u || !a) return null;
    return (u.series || String(unitPn).slice(0, 2)) + (battery === "8Ah" ? "08" : "05") + "-" + (a.sku || a.pn);
  }
  function findKit(unitPn, battery, adapterPn) {
    var sku = buildSku(unitPn, battery, adapterPn);
    return sku && DATA.kits[sku] ? Object.assign({ sku: sku }, DATA.kits[sku]) : null;
  }

  function money(cents) {
    if (cents == null || isNaN(cents)) return "";
    var n = Number(cents) / 100;
    var whole = Math.round(n) === n;
    return "$" + n.toLocaleString("en-US", { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }

  // The three fit states from the brand canon. `status` is a coverage flag;
  // an airplane can be listed and still need the Pro or SF frame.
  function classify(a) {
    if (!a) return "nomatch";
    if (a.status === "no_fit") return "nofit";
    if (a.status === "confirm") return "confirm-unconfirmed";
    if (a.unit === "6600" || a.unit === "6700") return "confirm-proSF";
    return "fits";
  }

  // Analytics names for the four verdicts (TRACKING-PLAN.md section 10).
  function resultName(state) {
    return { "fits": "fits", "confirm-proSF": "fits_pro_sf", "confirm-unconfirmed": "confirm", "nofit": "no_fit" }[state] || state;
  }
  function makeOf(a) {
    if (!a || !a.id) return "";
    return a.id.replace(/^nofit-/, "").split("-")[0];
  }

  function frameWord(unitPn) {
    if (unitPn === "6600") return "Pro";
    if (unitPn === "6700") return "SF";
    return "standard";
  }

  function glyph(kind) {
    if (kind === "yes") return '<svg class="rt-glyph rt-glyph--yes" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M6.5 12.5l3.6 3.6 7.4-8" fill="none" stroke="var(--rt-glyph-ink, #fff)" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    if (kind === "no") return '<svg class="rt-glyph rt-glyph--no" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M8 8l8 8M16 8l-8 8" fill="none" stroke="var(--rt-glyph-ink, #fff)" stroke-width="2.6" stroke-linecap="round"/></svg>';
    return '<svg class="rt-glyph rt-glyph--ask" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2"/><path d="M9.3 9.4a2.8 2.8 0 1 1 3.9 2.6c-.8.4-1.2.9-1.2 1.8v.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17.4" r="1.25" fill="currentColor"/></svg>';
  }

  function statusWord(a) {
    if (a.status === "no_fit") return { word: "Does not fit", kind: "no" };
    if (a.status === "confirm") return { word: "Confirm with us", kind: "ask" };
    if (a.unit === "6600") return { word: "Fits, Pro frame", kind: "yes" };
    if (a.unit === "6700") return { word: "Fits, SF frame", kind: "yes" };
    return { word: "Fits", kind: "yes" };
  }

  function phoneLink(cls) {
    if (!CFG.phoneTel) return "";
    return '<a class="' + (cls || "rt-btn rt-btn--ghost") + '" href="tel:' + esc(CFG.phoneTel) + '" data-rt-phone-location="fit_result">Call ' + esc(CFG.phoneDisplay) + "</a>";
  }

  // A known airplane rides in the URL (a library name). What a visitor typed never does: on a no-match
  // it is handed to the contact form through sessionStorage, so it cannot reach analytics or session replay.
  function photosLink(a, typed) {
    var name = a ? a.display : (typed || "");
    var contact = (CFG.contactPath || "/pages/contact") +
      (a ? "?airplane=" + encodeURIComponent(a.display) + "&ac=" + encodeURIComponent(a.id) : "");
    var out = '<a class="rt-btn rt-btn--signal" href="' + esc(contact) + '"' + (a ? "" : " data-rt-handoff") + '>Send photos of my nose gear</a>';
    if (CFG.fitEmail) {
      var subj = "Fit check: " + (name || "my airplane");
      out += '<a class="rt-btn rt-btn--ghost" href="mailto:' + esc(CFG.fitEmail) + "?subject=" + encodeURIComponent(subj) + '" data-rt-email-location="fit_result" data-rt-email-purpose="fit_photos">Email the photos</a>';
    }
    return out;
  }

  // The typed text is stashed only when the visitor actually taps through to the contact form.
  var handoffText = "";
  if (typeof document !== "undefined") document.addEventListener("click", function (e) {
    var link = e.target && e.target.closest ? e.target.closest("a[data-rt-handoff]") : null;
    if (!link || !handoffText) return;
    try { sessionStorage.setItem("rt_airplane", handoffText); } catch (err) { /* storage blocked: the form opens empty */ }
  }, true);

  function photoUrl(p) {
    if (!p) return "";
    if (/^(https?:)?\/\//.test(p)) return p;
    return (CFG.assetBase || "") + p;
  }

  // One result card for every entry point, so the three states read the same everywhere.
  function buildResultHTML(a, opts) {
    opts = opts || {};
    var state = classify(a);
    var kitPath = CFG.kitPath || "/products/robotow-2-0-kit";
    var adapterPath = CFG.adapterPath || "/products/aircraft-adapters";

    if (state === "fits" || state === "confirm-proSF") {
      var ad = getAdapter(a.adapter);
      var kit = findKit(a.unit, "5Ah", a.adapter);
      var photo = ad && ad.photos && ad.photos.length ? photoUrl(ad.photos[0]) : "";
      // fu: the follow-up answer already given, so the next page does not ask it again.
      var id = encodeURIComponent(a.id) + (opts.fu ? "&fu=" + encodeURIComponent(opts.fu) : "");
      var line = state === "fits"
        ? "Fits."
        : "Fits with the " + frameWord(a.unit) + " frame, confirm with us.";
      var body = state === "fits"
        ? "Your " + esc(a.display) + " takes the " + esc(ad ? ad.name : "matching adapter") + " on the standard frame."
        : "Your " + esc(a.display) + " takes the " + esc(ad ? ad.name : "matching adapter") + " on the " + frameWord(a.unit) +
          " frame. Call us and we will confirm the fit before it ships.";
      return (
        '<div class="rt-fit-result is-fits" data-state="' + state + '">' +
        (photo ? '<div class="rt-fit-photo"><img src="' + esc(photo) + '" alt="' + esc(ad.name) + ', shown on its own" loading="lazy" width="900" height="600"></div>' : "") +
        '<p class="rt-fit-line">' + glyph("yes") + "<span>" + line + "</span></p>" +
        "<p>" + body + "</p>" +
        (ad && ad.attach ? '<p class="rt-fit-meta"><b>How it attaches:</b> ' + esc(ad.attach) + "</p>" : "") +
        (kit ? '<p class="rt-fit-sku">Kit ' + esc(kit.sku) + " · 5Ah battery</p>" : "") +
        (kit && kit.price ? '<p class="rt-fit-price"><span class="rt-num">' + money(kit.price) + '</span><span class="rt-fit-price-note">Robotow 2.0 Kit, ' + frameWord(a.unit) + " frame</span></p>" : "") +
        (state === "fits" ? "<p>The Pro frame fits your airplane too. It folds and has a carry handle.</p>" : "") +
        '<div class="rt-fit-actions">' +
        '<a class="rt-btn rt-btn--signal" href="' + esc(kitPath) + "?ac=" + id + '">Build my kit</a>' +
        (state === "fits"
          ? '<a class="rt-btn rt-btn--ghost" href="' + esc(adapterPath) + "?ac=" + id + '">Just the adapter</a>'
          : phoneLink()) +
        "</div></div>"
      );
    }
    if (state === "confirm-unconfirmed") {
      return (
        '<div class="rt-fit-result is-ask" data-state="' + state + '">' +
        '<p class="rt-fit-line">' + glyph("ask") + "<span>Confirm with us.</span></p>" +
        "<p>We have not confirmed the " + esc(a.display) + " yet.</p>" +
        (a.fit_note ? "<p>" + esc(a.fit_note) + "</p>" : "") +
        "<p>Send two photos of the nose gear and the nose wheel size. We will tell you if it fits.</p>" +
        '<div class="rt-fit-actions">' + photosLink(a) + phoneLink() + "</div></div>"
      );
    }
    if (state === "nofit") {
      var isTail = /taildragger|tailwheel/i.test(a.display);
      return (
        '<div class="rt-fit-result is-no" data-state="' + state + '">' +
        '<p class="rt-fit-line">' + glyph("no") + "<span>Does not fit.</span></p>" +
        "<p>" + esc(a.fit_note || (a.display + " is not on the fit list.")) + "</p>" +
        "<p>Better you hear it from us now than after it ships.</p>" +
        '<div class="rt-fit-actions">' +
        phoneLink("rt-btn rt-btn--signal") +
        (isTail ? "" : '<a class="rt-btn rt-btn--ghost" href="' + esc((CFG.contactPath || "/pages/contact") + "?airplane=" + encodeURIComponent(a.display) + "&ac=" + encodeURIComponent(a.id)) + '">Ask about a custom adapter</a>') +
        '<button type="button" class="rt-link-btn" data-rt-restart>Check another airplane</button>' +
        "</div></div>"
      );
    }
    var typed = opts.typed || "what you typed";
    handoffText = (opts.typed || "").slice(0, 80);
    return (
      '<div class="rt-fit-result is-ask" data-state="nomatch">' +
      '<p class="rt-fit-line">' + glyph("ask") + "<span>Not on the list yet.</span></p>" +
      "<p>We don't have &ldquo;" + esc(typed) + "&rdquo; on our list yet. That is not a no. Call " + esc(CFG.phoneDisplay || "") + " or send two photos of the nose gear.</p>" +
      '<div class="rt-fit-actions">' + photosLink(null, opts.typed || "") + phoneLink() + "</div></div>"
    );
  }

  // Apply one follow-up answer. Outcomes: keep, route, confirm, no_fit, adapter.
  // "adapter": the airplane itself still fits, but the visitor's answer picks which adapter
  // style ships (e.g. Commander's hook vs. pin tow fitting). ans.target is an adapter pn,
  // looked up the same way a.adapter always is (Fit.getAdapter / findKit / buildSku).
  function resolveAnswer(a, ans) {
    if (!ans) return a;
    if (ans.outcome === "route") return getAircraft(ans.target) || a;
    if (ans.outcome === "adapter") return Object.assign({}, a, { adapter: ans.target, display: ans.display || a.display });
    if (ans.outcome === "confirm") return Object.assign({}, a, { status: "confirm" });
    if (ans.outcome === "no_fit") return Object.assign({}, a, { status: "no_fit", fit_note: ans.note || a.fit_note });
    return a;
  }

  function renderFollowUpChips(container, a, onDone) {
    var fu = a.follow_up;
    var chips = (fu.answers || []).map(function (ans, i) {
      return '<button type="button" class="rt-pill" aria-pressed="false" data-i="' + i + '">' + esc(ans.label) + "</button>";
    }).join("");
    var qid = "rt-q-" + Math.random().toString(36).slice(2, 8);
    container.innerHTML =
      '<div class="rt-fit-result is-question" data-state="question">' +
      '<p class="rt-fit-q" id="' + qid + '">' + esc(a.display) + ": " + esc(fu.q) + "</p>" +
      (fu.help ? '<p class="rt-fit-meta">' + esc(fu.help) + "</p>" : "") +
      '<div class="rt-chip-group" role="group" aria-labelledby="' + qid + '">' + chips + "</div></div>";
    var buttons = container.querySelectorAll(".rt-pill");
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener("click", function () {
        Array.prototype.forEach.call(buttons, function (b) { b.setAttribute("aria-pressed", "false"); });
        btn.setAttribute("aria-pressed", "true");
        onDone(resolveAnswer(a, fu.answers[Number(btn.getAttribute("data-i"))]), fu.answers[Number(btn.getAttribute("data-i"))]);
      });
    });
    var first = container.querySelector(".rt-pill");
    if (first && container.hasAttribute("data-rt-focus")) first.focus();
  }

  root.RobotowFit = {
    ready: ready,
    config: function () { return CFG; },
    data: function () { return DATA; },
    searchAircraft: searchAircraft,
    getAircraft: getAircraft,
    getAdapter: getAdapter,
    getUnit: getUnit,
    buildSku: buildSku,
    findKit: findKit,
    money: money,
    classify: classify,
    resultName: resultName,
    makeOf: makeOf,
    statusWord: statusWord,
    glyph: glyph,
    frameWord: frameWord,
    buildResultHTML: buildResultHTML,
    resolveAnswer: resolveAnswer,
    renderFollowUpChips: renderFollowUpChips,
    esc: esc
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", load);
  else load();
})(window);
